<template>
  <div class="blocks">
    <div class="top">库区周转率</div>
    <div class="blossomVideo">
      <div id="behaviorpie" :style="echartsStyle"></div>
      <div class="tab-switch">
        <span
          v-for="item in tabData"
          :class="[{'current': tabKey==item}]"
          v-text="item"
          :key="item"
          @click="tabSwitch(item);dataChang(item)"
        ></span>
      </div>
    </div>
  </div>
</template>
<script>
//柱状图组件
export default {
    
  name: "echarts03",
  props: {
    echartsData: {
      type: Array,
      default: () => {
        return [60, 90, 99, 80, 70, 77, 67];
      }
    },
    xData: {
      type: Array,
      default: () => {
        return ["11.1", "11.5", "11.10", "11.15", "11.20", "11.25", "11.30"];
      }
    },
    echartsStyle: {
      type: Object,
      default: () => {
        return {width:"300px",height:"180px"}
      }
    },
  },
  data() {
    let tabData = ["日", "周", "月"];
    //获取今日12点前时间
    let endTime = new Date(new Date(new Date().toLocaleDateString()).getTime() +24 * 60 * 60 * 1000 -1)
    return {
      tabData: tabData,
      tabKey: tabData[0],
      settime:endTime
    };
  },
  created() {
      
  },
  mounted() {
    this.pies();
  },
  methods: {
    tabSwitch(item) {
      // console.log(item);
      this.tabKey = item;
      //   this.getGzsjhzList();
    },
    dataChang(val) {
      this.$emit("receiveData",val)
    },
    pies() {
      var _this = this;
      var behaviorpie = this.$echarts.init(
        document.getElementById("behaviorpie")
      );
      var option = {
        //    backgroundColor: '#030C2D',
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          },
          //去掉鼠标移入阴影
          axisPointer: {
            type: ""
          },
          formatter: function(params) {
            //   console.log(params)
            return (
              params[0].name +
              "<br>" +
              //   params[0].seriesName +
              //   ":" +
              //   params[0].data +
              //   "<br>" +
              //   params[1].seriesName +
              //   ":" +
              params[0].data +
              "%"
            );
          }
        },
        grid: {
          left: "0",
          top: "14%",
          right: "0",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: _this.xData,
            splitLine: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: "rgba(255,255,255,0.12)"
              }
            },
            axisLabel: {
              color: "rgba(57,109,130,1)"
            },
             //设置刻度线：
            axisTick: {
              show: false
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            splitLine: {
              show: true,
              lineStyle: {
                color: "#111F48",
                width: 1
              }
            },
            axisLine: {
               show: false,
              lineStyle: {
                color: "rgba(57,109,130,1)"
              }
            },
            //设置刻度线：
            axisTick: {
              show: false
            },
            axisLabel: {
              show: true,
              interval: "auto",
              formatter: "{value} %"
            }
          }
        ],
        series: [
          {
            type: "bar",
            barWidth: 6,
            // barGap: "-100%",
            // stack: "广告",
            itemStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(0,183,189,1)" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(0,63,255,1)" // 100% 处的颜色
                    }
                  ],
                  false
                ),
                barBorderRadius: [30, 30, 30, 30]
                // shadowColor: "rgba(0,160,221,1)",
                // shadowBlur: 4
              },
              //设置百分比
              label: {
                show: true,
                position: "top",
                formatter: "{b}\n{c}%"
              }
            },
            data: _this.echartsData
          }
        ]
      };
      behaviorpie.setOption(option);
    }
  }
};
</script>
<style  scoped>
.blocks {
  width: 318px;
  height: 222px;
  background: url("../../assets/img/title-bg.png") no-repeat;
  position: relative;
  border-radius: 8px;
}
.top {
  position: absolute;
  left: 85px;
  top: -12px;
  width: 150px;
  height: 32px;
  color: #796423;
  text-align: center;
  line-height: 32px;
  background-image: linear-gradient(to right,#f8f1d5, #ffffff);
  border-radius: 8px;
}
.blossomVideo {
  width: 300px;
  height: 180px;
  position: absolute;
  top: 32px;
  left: 9px;
  border-radius: 6px;
}
/* img {
    height: 200px;
    width: 200px
} */
.tab-switch {
  width: 140px;
  height: 22px;
  position: absolute;
  right: 0px;
  top: -5px;
}
.tab-switch span {
  color: #fff;
  font-size: 12px;
  text-align: center;
  width: 20px;
  padding: 3px;
  margin: 0px 8px;
  line-height: 14px;
  height: 14px;
  display: inline-block;
  background-color: #1b406d;
  border-radius: 5px;
}
.current {
  background: #07afa1 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/xiayan/home/home/echarts03.vue